export default __webpack_public_path__ + "static/media/investmentrequested.7b75b611.png";